import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Button, Spinner } from "react-bootstrap";
import { FaEdit, FaPrint, FaArrowLeft } from "react-icons/fa";
import { useParams, useNavigate } from "react-router-dom";
import api from "../services/api";
import "./AddPurchase.css";

const ViewPurchase = () => {
  const [purchase, setPurchase] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchPurchaseData();
    }
  }, [id]);

  const fetchPurchaseData = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.post("/purchase_detail.php", { id });
      
      if (response.data.head.code === 200) {
        setPurchase(response.data.body);
      } else {
        setError(response.data.head.msg || "Purchase not found");
      }
    } catch (err) {
      console.error("Error fetching purchase:", err);
      setError("Failed to load purchase data");
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    window.open(`/sri_vinayaga_wires/purchaseprint/${purchase.id}`, '_blank');
  };

  if (loading) {
    return (
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Purchase Details</h4>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" /> Back
          </Button>
        </div>
        <div className="text-center py-5">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">Loading purchase details...</p>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Purchase Details</h4>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" /> Back
          </Button>
        </div>
        <div className="alert alert-danger" role="alert">
          {error}
          <button className="btn btn-sm btn-outline-danger ms-3" onClick={fetchPurchaseData}>
            Retry
          </button>
        </div>
      </Container>
    );
  }

  if (!purchase) {
    return (
      <Container className="mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">Purchase Details</h4>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" /> Back
          </Button>
        </div>
        <div className="text-center py-5">
          <p>Purchase not found.</p>
        </div>
      </Container>
    );
  }

  return (
    <Container className="mt-4">
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Purchase Details</h4>
        <div className="d-flex gap-2">
          {/* <Button className="btn-submit" onClick={handlePrint}>
            <FaPrint className="me-2" /> Print
          </Button> */}
          {/* <Button
            className="btn-submit"
            onClick={() => navigate(`/editpurchase/${purchase.id}`)}
          >
            <FaEdit className="me-2" /> Edit
          </Button> */}
          <Button className="btn-top" onClick={() => navigate(-1)}>
            <FaArrowLeft className="me-2" /> Back
          </Button>
        </div>
      </div>

      {/* Order ID, Date and Payment Info Section */}
      <div className="p-4 border rounded bg-light mb-4">
        <Row>
          {/* <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Purchase Code:</strong>
              <div className="fs-5 text-primary">{purchase.purchase_code}</div>
            </div>
          </Col> */}
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Purchase No:</strong>
              <div className="fs-5">{purchase.bill_no || "N/A"}</div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Date:</strong>
              <div className="fs-5">{purchase.date}</div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Payment Method:</strong>
              <div className="fs-5 text-capitalize">{purchase.payment_method}</div>
            </div>
          </Col>
          
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Payment Reference:</strong>
              <div className="fs-5">{purchase.payment_reference || "N/A"}</div>
            </div>
          </Col>
           <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Supplier Name:</strong>
              <div className="fs-5">{purchase.supplier_name}</div>
            </div>
          </Col>
          <Col lg={4} md={4} sm={12}>
            <div className="mb-3">
              <strong>Phone:</strong>
              <div className="fs-5">{purchase.mobile || "N/A"}</div>
            </div>
          </Col>
        </Row>
      </div>

      {/* Supplier Details Section */}
      {/* <div className="p-4 border rounded bg-light mb-4">
        <Row>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Supplier Name:</strong>
              <div className="fs-5">{purchase.supplier_name}</div>
            </div>
          </Col>
          <Col lg={6} md={6} sm={12}>
            <div className="mb-3">
              <strong>Phone:</strong>
              <div className="fs-5">{purchase.supplier_phone || "N/A"}</div>
            </div>
          </Col>
          <Col lg={12} md={12} sm={12}>
            <div className="mb-3">
              <strong>Address:</strong>
              <div className="fs-6">{purchase.supplier_address || "N/A"}</div>
            </div>
          </Col>
        </Row>
      </div> */}

      {/* Purchase Items Table */}
      <div className="table-responsive">
        <Table bordered className="purchase-table">
          <thead className="table-dark">
            <tr>
              <th width="5%" className="text-center">S.No</th>
              {/* <th width="15%">Product Code</th> */}
              <th width="25%">Item</th>
              <th width="10%">HSN Code</th>
              <th width="15%" className="text-end">Purchase Rate (₹)</th>
              <th width="10%">Qty</th>
              <th width="15%" className="text-end">Total (₹)</th>
            </tr>
          </thead>
          <tbody>
            {purchase.items && purchase.items.map((item, index) => (
              <tr key={item.id}>
                <td className="text-center">{index + 1}</td>
                {/* <td>PROD{String(item.product_id).padStart(3, '0')}</td> */}
                <td>{item.product_name}</td>
                <td>{item.hsn_code || "N/A"}</td>
                <td className="text-end">₹{parseFloat(item.purchase_rate).toFixed(2)}</td>
                <td>{item.quantity}</td>
                <td className="text-end">₹{parseFloat(item.total).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* Totals Section */}
      <Row className="mt-4">
        <Col xs={12} className="d-flex justify-content-end">
          <div className="totals-section">
            <div className="total-row">
              <span className="total-label">Subtotal:</span>
              <span className="total-value">₹{parseFloat(purchase.sub_total).toFixed(2)}</span>
            </div>
            <div className="total-row">
              <span className="total-label">
                GST ({purchase.gst_percentage}%)
              </span>
              <span className="total-value">₹{parseFloat(purchase.gst_amount).toFixed(2)}</span>
            </div>
            <div className="total-row grand-total">
              <span className="total-label">Grand Total:</span>
              <span className="total-value">₹{parseFloat(purchase.grand_total).toFixed(2)}</span>
            </div>
          </div>
        </Col>
      </Row>

      {/* Action Buttons */}
      {/* <div className="d-flex justify-content-end mt-4 gap-2">
        <Button className="btn-top" onClick={handlePrint}>
          <FaPrint className="me-2" /> Print Purchase
        </Button>
        <Button
          className="btn-submit"
          onClick={() => navigate(`/editpurchase/${purchase.id}`)}
        >
          <FaEdit className="me-2" /> Edit Purchase
        </Button>
        <Button className="btn-top" onClick={() => navigate("/purchaselist")}>
          <FaArrowLeft className="me-2" /> Back to List
        </Button>
      </div> */}
    </Container>
  );
};

export default ViewPurchase;